import { getAssetsFolder } from '@utilities/get-assets-folder';

// used only in local build
export const KRPANO_XML = getAssetsFolder('/krpano/krpano.xml');

export const KRPANO_SWF = getAssetsFolder('/krpano/krpano.swf');

export const KRPANO_FOV_INCREMENT = 30;
export const KRPANO_FOV_MIN = 70;
export const KRPANO_FOV_MAX = 140;

export const krpanoInternalEvents = {
    SCENE_CHANGE: 'krpano::sceneChange',
};

export const krpanoEmittedEvents = {
    TOGGLE_GO_BACK: 'krpano::goBackToggleEvent',
    TOGGLE_ZOOM_IN: 'krpano::zoomInToggleEvent',
    TOGGLE_ZOOM_OUT: 'krpano::zoomOutToggleEvent',
};
